import $ from "jquery";

const findBlockParent = ($jqLabel, call)=>{
    let $parent = $jqLabel.parent();
    while(true){
        if($parent.length == 0){
            break;
        }
        if(["p","div","P","DIV"].indexOf($parent[0].tagName) > -1){
            call($parent);
            break;
        }
        $parent = $parent.parent();
    }
};
const addSpecialClass = (content)=>{
    if(!content){
        return content;
    }
    let $container = $(`<div>${content}</div>`);
    $container.find("img").each(function () {
        findBlockParent($(this), ($parent)=>{
            if(!($parent.hasClass("vsbcontent_img"))){
                $parent.addClass("vsbcontent_img");
            }
        });
    });

    $container.find("[alias-label='video']").each(function () {
        findBlockParent($(this), ($parent)=>{
            if(!($(this).parent().hasClass("vsbcontent_video"))){
                $(this).parent().addClass("vsbcontent_video");
            }
        });
    });
    
    $container.find("iframe").each(function () {
        findBlockParent($(this), ($parent)=>{
            $parent.css("text-indent", 'initial');
        });
    });

    return $container.html();
};
export default addSpecialClass;